/***
 * Applying DRY to how we calculate stat hold period in the front-end from the
 * stat.data_frequency setting
 *
 * @param dataFrequency
 */
export function getStatHoldSeconds(dataFrequency: number): number {
    return dataFrequency ? dataFrequency * 2 : Infinity;
}
